export default "__VITE_ASSET__BjuYHqQi__"